import './nais.scss';
import './ts/calendars-regional';
import './ts/entity-items';
import './lib/contextmenu.js';
import './ts/nette-forms';
import './lib/sideDialog.js';
import './lib/jquery.are-you-sure.js';
import './lib/jquery.multisortable.js';
import './lib/dataTables_langs.js';
import './lib/dropzone.js';
import './lib/ckeditor.nais.js';

import {
    handleEntityPickerChoiceResponse,
    initCalendars,
    initCheckboxesBulkActions,
    initEntitiesAutocomplete,
    initEntitiesTables,
} from './lib/main.functions.js';
import { initEntityItemsControls } from './ts/entity-items';
import { initShell } from './ts/shell';
import { initWorkspaceBar } from './ts/workspace-bar';
import { initMenu } from './ts/menu';
import { initBootstrapComponents } from './ts/bootstrap';
import { initLayoutFlashes } from './ts/notifications';
import { initNetteBridge } from './ts/nette-bridge';
import { initDatagridConfirmDialogs, initDatagridFilterSelects } from './ts/datagrid';
import { initFileInputUploads } from './ts/file-input-upload';
import { initNativeChecks } from './ts/native-checks';
import { initSystemModule } from './ts/systemModule';
import { naisBootLogin } from './ts/login';
import { initRangeLinks } from './ts/range-link';
import { initLucideIcons } from './ts/lucide-icons';

function initLoginPage(): void {
    const loginRoot = document.getElementById('snippet--loginForm')
        ?? document.querySelector('.nais-login__form')
        ?? document;

    initLayoutFlashes();
    initBootstrapComponents(loginRoot);
    initNativeChecks(loginRoot);
    initNetteBridge();
    initLucideIcons(loginRoot);

    if (window.__naisLogin) {
        naisBootLogin();
    }
}

function initAdminPage(): void {
    initLayoutFlashes();
    initShell();
    initWorkspaceBar();
    initMenu();
    initBootstrapComponents();
    initNativeChecks();
    initFileInputUploads();
    initEntityItemsControls();
    initCalendars();
    initRangeLinks();
    initCheckboxesBulkActions();
    initEntitiesTables();
    initEntitiesAutocomplete();
    initDatagridConfirmDialogs();
    initDatagridFilterSelects();
    initNetteBridge();
    initLucideIcons();
}

document.addEventListener('DOMContentLoaded', () => {
    if (handleEntityPickerChoiceResponse()) {
        return;
    }

    initSystemModule();

    if (document.body.classList.contains('nais-login')) {
        initLoginPage();
        return;
    }

    initAdminPage();
});
